import React, { memo, useState, useEffect } from 'react';
import { Checkbox } from "tea-component";
import GeneralSelectFilter, { FilterItemType } from '@gp/components/GeneralSelectFilter';
import DateFilter, { IFilter } from '@gp/pages/StudioDashboard/StudioOverall/Tabs/People/Details/components/Filter';
import { useMemoizedFn } from 'ahooks';
import './index.scss';

interface FilterPropsType {
  loading: boolean,
  timeRangeData: {
    startDate: string,
    endDate: string,
  } | null,
  options: FilterItemType[],
  onChange: ((
    studio: string[],
    project: string[],
    date: IFilter,
    ym: string[],
    handleFilterName: string,
  ) => void) | null;
}

const DEFAULT_PROPS: FilterPropsType = {
  loading: true,
  timeRangeData: null,
  options: [],
  onChange: null,
};

function Filter(props: FilterPropsType) {
  const {
    loading,
    timeRangeData,
    options,
    onChange,
  } = props;

  const [selectValues, setSelectValues] = useState<{[keyName: string]: string[]}>({});
  const [selectYM, setSelectYM] = useState<string[]>(['1']);
  const [filter, setFilter] = useState<IFilter>({
    date_type: 'Month',
    start_date: '',
    end_date: '',
  });

  const handleSelectFilterChange = useMemoizedFn((payload, handleFilterName) => {
    setSelectValues(payload);
    onChange?.(
      payload?.studio || [],
      payload?.project || [],
      filter,
      selectYM,
      handleFilterName,
    );
  });

  const handleYMChange = useMemoizedFn((value: string[]) => {
    setSelectYM(value);
    onChange?.(
      selectValues?.studio || [],
      selectValues?.project || [],
      filter,
      value,
      'ym',
    );
  });

  const handleDateFilterChange = useMemoizedFn((payload: IFilter) => {
    const newFilter = { ...filter, ...payload };
    setFilter(newFilter);
    onChange?.(
      selectValues?.studio || [],
      selectValues?.project || [],
      payload,
      selectYM,
      'date',
    );
  });

  // 初始化默认日期，默认选当前年份所有月份，当前年份没有数据时，取最近年份所有月份
  useEffect(() => {
    if (
      loading
      || !timeRangeData?.startDate
      || !timeRangeData?.endDate
    ) {
      return;
    }
    const initEndDate = timeRangeData?.endDate || '';
    const initStartDate = Number(initEndDate?.substring(0, 4)) > Number(timeRangeData?.startDate?.substring(0, 4))
      ? `${initEndDate?.substring(0, 4)}-01-01` : timeRangeData?.startDate || '';
    // 初始化时
    if (!filter?.start_date && !filter?.end_date) {
      setFilter({
        date_type: 'Month',
        start_date: initStartDate,
        end_date: initEndDate,
      });
    }
  }, [
    timeRangeData?.startDate,
    timeRangeData?.endDate,
  ]);

  return (
    <div className="dbg-studio-monthly-report-gross-revenue-card-filter">
      <GeneralSelectFilter
        options={options}
        onChange={handleSelectFilterChange}
      />
      <DateFilter
        dateRangeData={loading ? undefined : {
          start_date: timeRangeData?.startDate || '',
          end_date: timeRangeData?.endDate || '',
        }}
        loading={loading}
        filter={filter}
        onFilterChange={handleDateFilterChange}
      />
      <Checkbox.Group
        className="dbg-gross-revenue-card-filter-ym-selector"
        value={selectYM}
        onChange={handleYMChange}
      >
        <Checkbox name="1">YoY</Checkbox>
        <Checkbox name="2">MoM</Checkbox>
      </Checkbox.Group>
    </div>
  );
}

Filter.defaultProps = DEFAULT_PROPS;

export default memo(Filter);
